import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
Vue.use(ViewUI);
Vue.prototype.$video = Video

Vue.use(MintUI)
Vue.config.productionTip = false
Vue.prototype.baseUrl = 'http://123.157.155.34:8092'


router.beforeEach((to, from, next) => {

	if (!to.name) {
		next('/search')
		return
	}
	next()
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
